import { PenNameTable } from './PenNameTable'
import { withPenNameTable } from './withPenNameTable'

const ConnectedPenNameTable = withPenNameTable(PenNameTable)
export { ConnectedPenNameTable as PenNameTable }
